import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SelectItem} from '@tj/tj-dmp-lib-api';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {ValidatorEditorService} from "../validator-editor.service";

@Component({
    selector: 'dmp-product-type-editor',
    templateUrl: './product-type-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class ProductTypeEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected translate: TranslateService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value;
    }

    ngOnInit(): void {
        this.value = this.value ? this.value.toUpperCase() : null;
        this.init();
        this.items = [{
            label: this.translate.instant('fields.values.product_type.flight'),
            value: 'FLIGHT'
        }, {
            label: this.translate.instant('fields.values.product_type.car'),
            value: 'CARRENTAL'
        }, {
            label: this.translate.instant('fields.values.product_type.parking'),
            value: 'PARKING'
        }, {
            label: this.translate.instant('fields.values.product_type.hotel'),
            value: 'HOTEL'
        }];
        this.disable = this.value === 'null';
    }
}
